import { Color, Vector4 } from 'three';
import { resolvePaletteColor } from './colors';
export function packShading(shading = '#ffffff', opacity = 1, palette) {
    const result = new Vector4();
    const shadingColor = new Color(resolvePaletteColor(shading, palette));
    result.set(shadingColor.r, shadingColor.g, shadingColor.b, 1);
    result.setW(opacity);
    return result;
}
